export const GENDERS = [
  {
    text: 'Не выбрано',
    value: 'N',
  },
  {
    text: 'Мужской',
    value: 'M',
  },
  {
    text: 'Женский',
    value: 'W',
  },
];


// WEBPACK FOOTER //
// ./src/components/ordersProcessForms/parts/AdditionalDataStep/type.ts